import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Contacto, TipoContacto } from '../../../interfaces/contacto';
import { FlujoTrabajo } from '../../../interfaces/flujo-trabajo';
import { GrupoUsuario } from '../../../interfaces/grupo-usuario';
// import { Contacto, TipoContacto } from '../../../../interfaces/contacto';
import { ContactoService } from '../../../providers/contacto.service';
import { UsuarioService } from '../../../providers/usuario.service';
// import { ContactoService } from '../../../../providers/contacto.service';
// import { Telefono, telefonoValidator } from '../../../../components/telefono/telefono.component';

@Component({
  selector: 'app-grupo-usuario',
  templateUrl: './grupo-usuario.component.html',
  styleUrls: ['./grupo-usuario.component.scss']
})
export class GrupoUsuarioComponent implements OnInit {
  @Input() grupoData: any = null;

  usuarios: any[] = [];
  grupo: GrupoUsuario;


  @Output() onContactoInput = new EventEmitter(); // datos del formulario cambian
  @Output() formState = new EventEmitter(); // emite el estado del formulario

  nombreFormControl = new FormControl('', [
    Validators.required
  ]);

  constructor(
    private usuarioService: UsuarioService
  ) { }

  ngOnInit(): void {
    if (this.grupoData) {
      console.log(this.grupoData);      
      this.grupo = new GrupoUsuario(
        this.grupoData.id,
        this.grupoData.descripcion,
        0,
        this.grupoData.usuarios,
      );

    } else {
      this.grupo = new GrupoUsuario();

    }
    this.traerUsuarios()
  }

  traerUsuarios() {
    this.usuarioService.getUsuarios(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'nombre',
        order: null
      },
      {
        generico: null
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.usuarios) {
          respuesta.data.usuarios.forEach(usuario => {
            this.usuarios.push(
              {
                'id': usuario.id,
                'nombre': usuario.nombre + ' ' + usuario.apellido
              }
            );
          });
        }
      }, (err) => {

      }
    );


  }

  onInput(): void { // cuando cambia un dato del formulario emitimos un evento
    this.onContactoInput.emit();
  }

  getGrupo(): GrupoUsuario {
    if (this.nombreFormControl.hasError('required')) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.nombreFormControl.markAsTouched();
      throw "Datos incorrectos";
    }

    return this.grupo;
  }
}